module.exports = __webpack_public_path__ + "img/projectpreview.54e160ce.jpg";